import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Footer } from './components/ds/Footer';
import { TopTrustBar } from './components/landing-v2/TopTrustBar';
import { HeaderV2 } from './components/landing-v2/HeaderV2';
import { HeroV2 } from './components/landing-v2/HeroV2';
import { LogoStrip } from './components/landing-v2/LogoStrip';
import { WhyOfriV2 } from './components/landing-v2/WhyOfriV2';
import { InlineCTA } from './components/landing-v2/InlineCTA';
import { TestimonialsV2 } from './components/landing-v2/TestimonialsV2';
import { StatsBar } from './components/landing-v2/StatsBar';
import { FAQ } from './components/landing/FAQ';
export function App() {
  const [showToast, setShowToast] = useState(false);
  const handleSubmit = (plz: string, description?: string) => {
    setShowToast(true);
    console.log('Form submission:', {
      plz,
      description
    });
    setTimeout(() => setShowToast(false), 1500);
  };
  return <div className="min-h-screen bg-white" data-id="element-0">
      <AnimatePresence data-id="element-1">
        {showToast && <motion.div initial={{
        opacity: 0,
        y: -50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -50
      }} className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] bg-ofri-blue text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2" data-id="element-2">
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-3" />
            <span className="font-medium" data-id="element-4">Sie werden weitergeleitet…</span>
          </motion.div>}
      </AnimatePresence>

      <TopTrustBar data-id="element-5" />
      <HeaderV2 data-id="element-6" />
      <HeroV2 onSubmit={handleSubmit} data-id="element-7" />
      <LogoStrip data-id="element-8" />
      <WhyOfriV2 data-id="element-9" />
      <TestimonialsV2 data-id="element-10" />
      <InlineCTA onSubmit={handleSubmit} variant="light" data-id="element-11" />
      <StatsBar data-id="element-12" />
      <FAQ data-id="element-13" />
      <InlineCTA onSubmit={handleSubmit} heading="Starten Sie Ihr Malerprojekt" subheading="Kostenlos, unverbindlich und in nur 2 Minuten." variant="dark" data-id="element-14" />
    </div>;
}